import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { HouseholdExpensesContent } from './household-expenses-content';
import { useFetchPlanStateIfNull, useFetchStateDataIfNull, useQuery } from '../../util/hooks';

export const HouseholdExpensesPage = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);
  useFetchPlanStateIfNull();

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <HouseholdExpensesContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
